/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {LocationStrategy} from '@angular/common';
import {Directive, HostBinding, HostListener, Input, OnChanges} from '@angular/core';

import {Router} from '../router';
import {ActivatedRoute} from '../router_state';
import {UrlTree} from '../url_tree';
export class RouterLink {
  private commands: any[] = []; queryParams: {[k: string]: any}; fragment: string;

  urlTree: UrlTree;

  /**
   * @internal
   */
  constructor(
      private router: Router, private route: ActivatedRoute,
      private locationStrategy: LocationStrategy) {}
  set routerLink(data: any[]|string) {
    if (Array.isArray(data)) {
      this.commands = data;
    } else {
      this.commands = [data];
    }
  }
  onClick(button: number, ctrlKey: boolean, metaKey: boolean): boolean {
    if (button !== 0 || ctrlKey || metaKey) {
      return true;
    }

    this.router.navigate(
        this.commands,
        {relativeTo: this.route, queryParams: this.queryParams, fragment: this.fragment});
    return false;
  }
/** @nocollapse */
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: ':not(a)[routerLink]'}, ] },
];
/** @nocollapse */
static ctorParameters: {type: Function, decorators?: DecoratorInvocation[]}[] = [
{type: Router, },
{type: ActivatedRoute, },
{type: LocationStrategy, },
];
/** @nocollapse */
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'queryParams': [{ type: Input },],
'fragment': [{ type: Input },],
'routerLink': [{ type: Input },],
'onClick': [{ type: HostListener, args: ['click', ['$event.button', '$event.ctrlKey', '$event.metaKey'], ] },],
};
}
export class RouterLinkWithHref implements OnChanges { target: string;
  private commands: any[] = []; queryParams: {[k: string]: any}; fragment: string; href: string;

  urlTree: UrlTree;

  /**
   * @internal
   */
  constructor(
      private router: Router, private route: ActivatedRoute,
      private locationStrategy: LocationStrategy) {}
  set routerLink(data: any[]|string) {
    if (Array.isArray(data)) {
      this.commands = data;
    } else {
      this.commands = [data];
    }
  }

  ngOnChanges(changes: {}): any { this.updateTargetUrlAndHref(); }
  onClick(button: number, ctrlKey: boolean, metaKey: boolean): boolean {
    if (button !== 0 || ctrlKey || metaKey) {
      return true;
    }

    if (typeof this.target === 'string' && this.target != '_self') {
      return true;
    }

    this.router.navigateByUrl(this.urlTree);
    return false;
  }

  private updateTargetUrlAndHref(): void {
    this.urlTree = this.router.createUrlTree(
        this.commands,
        {relativeTo: this.route, queryParams: this.queryParams, fragment: this.fragment});
    if (this.urlTree) {
      this.href = this.locationStrategy.prepareExternalUrl(this.router.serializeUrl(this.urlTree));
    }
  }
/** @nocollapse */
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: 'a[routerLink]'}, ] },
];
/** @nocollapse */
static ctorParameters: {type: Function, decorators?: DecoratorInvocation[]}[] = [
{type: Router, },
{type: ActivatedRoute, },
{type: LocationStrategy, },
];
/** @nocollapse */
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'target': [{ type: Input },],
'queryParams': [{ type: Input },],
'fragment': [{ type: Input },],
'href': [{ type: HostBinding },],
'routerLink': [{ type: Input },],
'onClick': [{ type: HostListener, args: ['click', ['$event.button', '$event.ctrlKey', '$event.metaKey'], ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
